import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ViewProductDetail } from "../../../../redux/services/ProductService/product.Services";
import { errorToast } from "../../../../Utils/toast";
import ProductProfileCard from "./ProductProfileCard";
import ProductDescriptionCard from "./ProductDescriptionCard";
// import ProductImagesCard from "./";
import ProductSpecificationCard from "./ProductSpecificationCard";
import ProductVariantCard from "./ProductVariantCard";
import ProductInventoryCard from "./ProductInventoryCard";
import ProductTaxCard from "./ProductTaxCard";
import { getViewConfig } from "../CreateProductModuls/Config/getViewConfig"; // ⭐

import "../../../../assets/css/viewProduct.css";

function ViewProduct() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchProductData();
    }, [id]);

    const fetchProductData = async () => {
        if (!id) {
            errorToast("Product ID is missing");
            navigate("/product-list");
            return;
        }

        try {
            setLoading(true);
            const response = await ViewProductDetail({ id });

            if (response?.data?.success) {
                setProduct(response.data.data);
            } else {
                errorToast(response?.data?.message || "Product not found");
                navigate("/product-list");
            }
        } catch (error) {
            console.log("Error fetching product:", error);
            errorToast("Failed to load product data");
            navigate(-1);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (!product) {
        return (
            <div className="text-center py-5">
                <h4>Product not found</h4>
                <button className="btn btn-primary mt-3" onClick={() => navigate(-1)}>
                    Go Back
                </button>
            </div>
        );
    }

    const config = getViewConfig(product);
    const components = config.components || {};
    const specifications = config.specifications || [];

    return (
        <div className="view-product-container">
            <div className="view-product-header">
                <div className="d-flex justify-content-end align-items-end">
                    <button className="btn btn-primary" onClick={() => navigate(-1)}>
                        Back
                    </button>
                </div>
            </div>

            <div className="view-product-body">
                <ProductProfileCard product={product} />
                {components.description && (
                    <ProductDescriptionCard product={product} />
                )}
                {/* {components.image && (
                    <ProductImagesCard product={product} />
                )} */}
                {components.specifications && (
                    <ProductSpecificationCard
                        product={product}
                        specifications={specifications} 
                    />
                )}
                {components.variants && (
                    <ProductVariantCard product={product} />
                )}
                {components.inventory && (
                    <ProductInventoryCard product={product} />
                )}
                {components.tax && (
                    <ProductTaxCard product={product} />
                )}
            </div>
        </div>
    );
}

export default ViewProduct;